import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Header.scss";
import Aside from "../../component/aside/Aside";
import logo from "../../assets/images/logo.svg";
import user_Icon from "../../assets/images/user.svg";
import Close from "../../assets/images/closeButton.svg";
import logoWhite from "../../assets/images/whitelogo.svg";

const Header = ({ setActiveTab, activeTab }) => {
  const navigate = useNavigate();
  const { customerDetailsData } = useSelector((state) => state.customerDetails);

  let customerDetailsDataAlternative = localStorage.getItem("customerDetails");
  if (!customerDetailsDataAlternative) {
    customerDetailsDataAlternative = JSON.parse(
      localStorage.getItem("customerDetails") || "{}"
    );
  }

  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };
  useEffect(() => {
    if (showNavbar) {
      document.body.classList.add("no-scroll");

      // console.log(activeTab);
      if (activeTab !== "v-pills-home") {
        // console.log("need to close");
      }
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup function to remove the class when component unmounts
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [showNavbar, activeTab]);

  return (
    <>
      <header className="header1">
        <nav className={`navbar ${showNavbar === true ? "active" : ""}`}>
          <div className="container d-flex">
            <div className="logo col-lg-4">
              <Link to="/home">
                {showNavbar === true ? (
                  <img className="navbar-brand" src={logoWhite} alt="" />
                ) : (
                  <img className="navbar-brand" src={logo} alt="" />
                )}
              </Link>
            </div>
            <div className="menu-icon " onClick={handleShowNavbar}>
              {showNavbar === true ? (
                <img src={Close} alt="" width={"100%"} />
              ) : (
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
              )}
            </div>
            <div className={`nav-elements  ${showNavbar && "active"} col-lg-8`}>
              <ul className="desktop_content">
                <li className="nav-item">
                  <span className="nav-link">
                    <NavLink
                      to="/home"
                      className={({ isActive }) => {
                        const urlArr = window.location.href.split("/");
                        const pathname = urlArr[urlArr.length - 1];
                        return isActive ||
                          pathname === "dlf-malls" ||
                          pathname === "avenueMalls" ||
                          pathname === "contact-us" ||
                          pathname === "privacy-policy" ||
                          pathname === "terms" ||
                          pathname === "edit-profile"
                          ? "active_footer"
                          : "";
                      }}
                    >
                      My Account
                    </NavLink>
                  </span>
                </li>
                {/* <li className="nav-item">
                  <span className="nav-link ">
                    <NavLink
                      to="/offers"
                      className={({ isActive }) =>
                        isActive ? "active_footer" : ""
                      }
                    >
                      Offers
                    </NavLink>
                  </span>
                </li> */}
                <li className="nav-item">
                  <span className="nav-link ">
                    <NavLink
                      to="/tier-history"
                      className={({ isActive }) =>
                        isActive ? "active_footer" : ""
                      }
                    >
                      Tier Benefits
                    </NavLink>
                  </span>
                </li>
                <li className="nav-item">
                  <span className="nav-link ">
                    <NavLink
                      to="/rewards-catalogue"
                      className={({ isActive }) =>
                        isActive ? "active_footer" : ""
                      }
                    >
                      Rewards
                    </NavLink>
                  </span>
                </li>
                <li className="nav-item">
                  <span className="nav-link ">
                    <NavLink
                      to="/feedback"
                      className={({ isActive }) =>
                        isActive ? "active_footer" : ""
                      }
                    >
                      Feedback
                    </NavLink>
                  </span>
                </li>
              </ul>

              <div
                className="nav-link usename desktop_content"
                onClick={() => navigate("/edit-profile")}
              >
                <img src={user_Icon} alt="" />
                {Object?.keys(customerDetailsData || {})?.length > 0 ? (
                  <>
                    {customerDetailsData?.firstname
                      ? customerDetailsData?.firstname
                      : "-"}{" "}
                    {customerDetailsData?.lastname}
                  </>
                ) : (
                  <>
                    {customerDetailsDataAlternative?.firstname
                      ? customerDetailsDataAlternative?.firstname
                      : "-"}{" "}
                    {customerDetailsDataAlternative?.lastname}
                  </>
                )}
              </div>
              <div className="header_aside">
                <Aside
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  closeNavbar={handleShowNavbar}
                />
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
